/**
* Include your custom JavaScript here.
*
* We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
* changes on product page, you can attach a listener to the document:
*
* document.addEventListener('variant:changed', function(event) {
*   var variant = event.detail.variant; // Gives you access to the whole variant details
* });
*
* You can also add a listener whenever a product is added to the cart:
*
* document.addEventListener('product:added', function(event) {
*   var variant = event.detail.variant; // Get the variant that was added
*   var quantity = event.detail.quantity; // Get the quantity that was added
* });
*
* If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
* "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
*
* document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
*   bubbles: true
* }));
*/

// Detect iPad

if (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints > 0) {
  document.body.classList.add('disable-scrollsnap');
};

document.addEventListener('variant:changed', function(event) {
  const variantAvailable = event.detail.variant.available,
        stockNotices = document.querySelectorAll('.container-in-stock'),
        qtySelector = document.querySelector('.ProductForm__QuantitySelector');

  if (variantAvailable === false) {
    if (stockNotices) {
      stockNotices.forEach(stockNotice => {
        stockNotice.style.display = 'none';   
      });
    }
    if (qtySelector) {
      qtySelector.style.display = 'none';
    }
  } else {
    if (stockNotices) {
      stockNotices.forEach(stockNotice => {
        stockNotice.style.display = 'block';   
      });
    }
    if (qtySelector) {
      qtySelector.style.display = 'block';
    }
  }

  if (document.getElementsByClassName('ProductForm__Inventory')[0]) {
    var variant_inventory_message = document.getElementsByClassName('ProductForm__Inventory')[0].innerHTML,
        variant_inventory = variant_inventory_message.match(/\d+/)[0],
        qtyInput = document.getElementById('qtyInput');
    qtyInput.setAttribute('max', variant_inventory);
  }
});


const element = document.querySelector('.wrapper--fullscreen__plus .videoContent__wrapper');
if (element) {
  const height = element.offsetHeight;
  document.documentElement.style.setProperty('--video-content-height', `${height}px`);
}
